module.exports = __webpack_public_path__ + "entry_handing-1359d9f4a42a4d2de2b25418f2dad2c4.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/screens/main/screens/phases/phaseShow/tabs/ifiTemplate/templates/assets/entry_handing.png
// module id = sTdn
// module chunks = client